import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";

const SubmitPage = ({ showSubmitSuccessMessage }) => {
  const onboardingSuccessMessage = (
    <Fragment>
      <h3 className="p-3 mb-2">
        Thanks for Providing your Details
      </h3>
      <h5>We will contact you if required!</h5>
    </Fragment>
  );

  const onboardingSubmittedMessage = (
    <Fragment>
      <h3 className="p-3 mb-2">
        Details are already Submitted
      </h3>
      <h5>Please contact HR Team for any corrections/updates!</h5>
    </Fragment>
  );

  return (
    <div className="final-message text-center">
      {showSubmitSuccessMessage
        ? onboardingSuccessMessage
        : onboardingSubmittedMessage}
      <p>
        Click here to{" "}
        <NavLink to="/" activeClassName="text-decoration-none">
          Sign Out
        </NavLink>
        .
      </p>
    </div>
  );
};

export default SubmitPage;
